// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__YR1lT","selects":"Documents_selects__3Jxkx"};